import React from 'react';
import Icon from '../../../components/AppIcon';

const IncomeTabNavigation = ({ activeTab, onTabChange, incomeSources }) => {
  const getIncomeCountByType = (type) => {
    if (type === 'all') return incomeSources.length;
    return incomeSources.filter(source => source.type === type).length;
  };

  const getTotalAmountByType = (type) => {
    const filteredSources = type === 'all' 
      ? incomeSources 
      : incomeSources.filter(source => source.type === type);
    
    return filteredSources.reduce((sum, source) => {
      const multipliers = {
        monthly: 12,
        quarterly: 4,
        annually: 1,
        'one-time': 1
      };
      return sum + (source.currentAmount * (multipliers[source.frequency] || 1));
    }, 0);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  const tabs = [
    {
      id: 'all',
      label: 'All Income',
      icon: 'LayoutGrid',
      color: 'primary'
    },
    {
      id: 'salary',
      label: 'Salary',
      icon: 'Briefcase',
      color: 'primary'
    },
    {
      id: 'business',
      label: 'Business',
      icon: 'Building2',
      color: 'accent'
    },
    {
      id: 'rental',
      label: 'Rental',
      icon: 'Home',
      color: 'warning'
    },
    {
      id: 'passive',
      label: 'Passive',
      icon: 'Coins',
      color: 'secondary'
    }
  ];

  return (
    <div className="border-b border-border mb-8">
      <nav className="flex space-x-8 overflow-x-auto">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          const count = getIncomeCountByType(tab.id);
          const totalAmount = getTotalAmountByType(tab.id);
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                flex items-center gap-3 px-4 py-4 border-b-2 transition-all duration-200 whitespace-nowrap
                ${isActive 
                  ? `border-${tab.color} text-${tab.color}` 
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                }
              `}
            >
              <div className={`
                w-8 h-8 rounded-lg flex items-center justify-center
                ${isActive 
                  ? `bg-${tab.color}/10 text-${tab.color}` 
                  : 'bg-muted text-muted-foreground'
                }
              `}>
                <Icon name={tab.icon} size={16} />
              </div>
              
              <div className="flex flex-col items-start">
                <div className="flex items-center gap-2">
                  <span className="font-medium">{tab.label}</span>
                  {count > 0 && (
                    <span className={`
                      px-2 py-0.5 rounded-full text-xs font-medium
                      ${isActive 
                        ? `bg-${tab.color}/10 text-${tab.color}` 
                        : 'bg-muted text-muted-foreground'
                      }
                    `}>
                      {count}
                    </span>
                  )}
                </div>
                {totalAmount > 0 && (
                  <span className="text-xs text-muted-foreground">
                    {formatCurrency(totalAmount)}/year
                  </span>
                )}
              </div>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default IncomeTabNavigation;